import { KBarMount, KBarButton, toggleKBar } from '@aytm/lib/kbar/index'
import { createRoot, IReactRoot } from '@aytm/lib/common/reactCreateRoot'

let reactRoot: IReactRoot = null
let buttonRoot: IReactRoot = null

declare global {
  interface Window {
    toggleKBar: typeof toggleKBar
  }
}

window.toggleKBar = toggleKBar

document.addEventListener('DOMContentLoaded', () => {
  const kbarContainer = document.querySelector('#kbar')

  if (kbarContainer) {
    reactRoot = createRoot(kbarContainer)
    reactRoot.render(<KBarMount />)
  }

  const kbarFooterButton = document.querySelector('#kbar-footer-button')

  if (kbarFooterButton) {
    buttonRoot = createRoot(kbarFooterButton)
    buttonRoot.render(<KBarButton />)
  }

  document.addEventListener('click', event => {
    const target = event.target as HTMLElement
    const link = target.closest('a[data-kbar-trigger]')

    if (link) {
      event.preventDefault()

      const oldMenus = document.querySelectorAll('#main-menu .item-menu.opened')
      oldMenus?.forEach(menu => {
        menu.classList.remove('opened')
        // The entry announces the group it owns; closing one here bypasses the menu's own
        // close path, so the announcement has to be corrected alongside the class.
        menu.querySelector(':scope > span.item-a')?.setAttribute('aria-expanded', 'false')
      })

      const newMenus = document.querySelectorAll('.-header__menu__item--opened')
      newMenus?.forEach(menu => {
        menu.classList.remove('-header__menu__item--opened')
      })

      toggleKBar()
    }
  })
})
